import { Global } from '@emotion/react';

export const Fonts = () => {
  return (
    <Global
      styles={`
        @font-face {
          font-family: 'Abhaya Libre';
          font-style: normal;
          font-weight: 400;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/AbhayaLibre-Regular.ttf') format("truetype")
        }

        @font-face {
          font-family: 'Abhaya Libre';
          font-style: normal;
          font-weight: 500;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/AbhayaLibre-SemiBold.ttf') format("truetype")
        }

        @font-face {
          font-family: 'Abhaya Libre';
          font-style: normal;
          font-weight: 700;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/AbhayaLibre-Bold.ttf') format("truetype")
        }

        @font-face {
          font-family: 'OPEN SANS';
          font-style: normal;
          font-weight: 200;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/OpenSans-Light.ttf') format("truetype")
        }

        @font-face {
          font-family: 'OPEN SANS';
          font-style: normal;
          font-weight: 500;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/OpenSans-Regular.ttf') format("truetype")
        }

        @font-face {
          font-family: 'OPEN SANS';
          font-style: normal;
          font-weight: 600;
          src: url('${location.origin}${
            import.meta.env.VITE_PUBLIC_URL
          }/fonts/OpenSans-SemiBold.ttf') format("truetype")
        }
      `}
    />
  );
};
